import { styled } from '@mui/system'
import { Box, MenuItem, Select } from '@mui/material'

export const SelectWrapper = styled(Box)(
  (props) => `
  width:100%;
  display:flex;
  flex-direction:column;
`)

export const SelectThemeV2Wrapper = styled(Box)(`
  & > label  {line-height:1; height:auto; padding:0; font-size:13px; color:#686867;}
	& > .multiSelectWrap  {	
    height: 36px !important;
    line-height:1;
    width: 100%;
    padding: 0;
    border-radius: 4px;
    border: 1px solid #E0E0DE;
    background: #FFF;
    position:relative;
  }
	& > .multiSelectWrap.showPlaceHolder .MuiInputBase-root { 
    margin-top: -36px;    
  }
	& > .multiSelectWrap .MuiInputBase-root { 
    box-shadow: none; 
    min-width:80px; 
    height:auto; 
    // padding-left: 8px;
    // padding-right: 20px;
    width:100%;
    height: 36px;
    line-height: 36px;
  }
	& > .multiSelectWrap .selectPlaceholder { 
    margin-left: 0; color:#454545; opacity:1; font-size:13px; line-height:1; font-weight:400; white-space: nowrap;
    text-overflow: ellipsis; padding-left: 8px; height: 36px; line-height: 36px;  overflow: hidden;
  }
	& > .multiSelectWrap .MuiSelect-icon { right: 5px; }
	& > .multiSelectWrap fieldset { display: none; }
	& > .multiSelectWrap .Mui-focused > div { background: transparent; }
	& > .multiSelectWrap .MuiInputBase-root:before, 	& > .multiSelectWrap .MuiInputBase-root:after { display: none; }
	& > .multiSelectWrap .MuiSelect-select { padding:0 0 0 8px; font-size: 13px; line-height: 37px; color:#454545; font-weight:400; position:relative; z-index:2; height:36px; overflow: hidden; text-overflow: ellipsis; }
  & > .multiSelectWrap svg {position: absolute; top: 8px; right: 1px; z-index:1;}
`)

export const FormLabel = styled('label')(`
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 14px;
  line-height: 19px;
  color: #000;
  width:100%;
  padding-bottom:10px;
`)

export const FormError = styled(Box)(`
  font-size: 0.75rem;
  font-weight: 400;
  margin: 4px 14px 0 14px;
  color: #D14343;
`)

export const FormSelectWrap = styled(Box)(`
  position: relative;
`)

export const InputLabel = styled(Box)(
  (props) => `
  margin-left: 15px;
  margin-bottom: -30px;
  margin-top: 0;
  opacity: 50%;
  font-size: 12px;
  z-index: 0;
  position: absolute;
  width: fit-content;
  line-height: 40px;
  height: 100%;
  display: flex;
  align-items: center;
`
)

export const StyledMenuItem = styled(MenuItem)(
  (props) => `
  min-height: ${props.compact ? '42px' : 'auto'};
  flex-direction: ${props.compact && !props.single ? 'row-reverse' : 'row'};
  paddingLeft: ${props.compact ? '10px' : '20px'};
  font-size: ${props.compact ? '12px' : '16px'};
  white-space: normal;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  & span {
    font-size: ${props.compact ? '12px' : '16px'};
  }
  &.small *{
    font-size: 13px;
  }
    
  &.Mui-selected {background: transparent;}
  &.Mui-selected:hover {background: rgba(55, 65, 81, 0.04);}
`
)

export const StyledSelect = styled(Select)(
  (props) => `
  background: transparent;
  font-size: ${props.compact ? '12px' : '16px'};
  height: ${props.compact ? '34px' : 'auto'};
  box-shadow: ${props.compact ? '0px 1px 2px rgba(16, 24, 40, 0.12)' : ''};
  & legend{
    width: ${props.compact ? '0' : 'auto'};
  }
  &.MuiOutlinedInput-root{
    &.Mui-disabled {
      background: #F7F7F9 !important;
    }
  }
  & img {
    margin-top: 3px;
    width: 12px;
    right: 13px;
  }

  & .dropdownArrow {
    margin: 0;
    padding: 0;
    position: absolute;
    right: 0;
    top: 8px;
  }

`)

export const FieldWrapper = styled(Box)(`
  padding: 0 16px;
  margin: 12px 0;

  & .themeV2 .searchBox input {padding : 0 4px;}

`)